import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { DocumentsContextProvider } from 'Context/DocumentsContext';
import { Lobby } from './Lobby';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const Documents = () => {
  return (
    <>
      <CustomMetaTitle title={Dictionary[DICTIONARY.Documents].title} />
      <LinkReturnToMain />
      <DocumentsContextProvider>
        <Lobby />
      </DocumentsContextProvider>
    </>
  );
};
